import React, { Component } from 'react';
import { connect } from 'react-redux';
import connectCommon from '../common/common-hoc';
import history from '../../routes/history';
import { 
    AssessmentContainer, 
    AssessmentContentCenteredSection,
    AssessmentBody, 
    AssessmentContent, 
    AssessmentNavigationPrevious, 
    AssessmentNavigationNext, 
    AssessmentFooter 
} from '../assessment/common';

class FinalTerminationScreen extends Component {
    componentDidMount() {
        window.history.pushState(null, null, history.location.href);
        window.onpopstate = function(event) {
            history.go(1);
        };
    }

    render() {
        return (
            <AssessmentContainer> 
                <AssessmentBody>
                    <AssessmentNavigationPrevious />
                    <AssessmentContent>
                        <AssessmentContentCenteredSection>
                            Thank you, please close the browser.
                        </AssessmentContentCenteredSection>
                    </AssessmentContent>
                    <AssessmentNavigationNext />
                </AssessmentBody>
                <AssessmentFooter includeProgress={false}></AssessmentFooter>
            </AssessmentContainer>
        )
    }
}

export default connect(null)(connectCommon(FinalTerminationScreen));